import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DatosEmisionComponent } from './datos-emision/datos-emision.component';
import { DatosEmisionRenovacionComponent } from './datos-emision-renovacion/datos-emision.component';
import { DatosEmisionVehiculoComponent } from './datos-emision-vehiculo/datos-emision-vehiculo.component';
import { DatosEmisionVehiculoRenovacionComponent } from './datos-emision-vehiculo-renovacion/datos-emision-vehiculo.component';
import { InicioComponent } from './inicio/inicio.component';
import { DatosTarjetaComponent } from './datos-tarjeta/datos-tarjeta.component';
import { DatosTarjetaRenovacionComponent } from './datos-tarjeta-renovacion/datos-tarjeta.component';
import { PagoEnLineaRenovacionComponent } from './datos-tarjeta-renovacion/pago-en-linea/pago-en-linea.component';
import { PagoEnLineaGnpRenovacionComponent } from './datos-tarjeta-renovacion/pago-en-linea/pago-en-linea-gnp/pago-en-linea-gnp.component';
import { DatosVehiculoComponent } from './datos-vehiculo/datos-vehiculo.component';
import { FinalComponent } from './final/final.component';
import { LoginComponent } from './tools/login/login.component';
import { LoginAyudaComponent } from './login-ayuda/login-ayuda.component';
import { PagoEnLineaComponent } from './datos-tarjeta/pago-en-linea/pago-en-linea.component';
import { NoEstaAutoComponent } from './datos-vehiculo/no-esta-auto/no-esta-auto.component';
import { LoginAuthComponent } from './login-auth/login-auth.component';
import { NotificacionComponent } from './tools/notificacion/notificacion.component';
import { PagoEnLineaGnpComponent } from './datos-tarjeta/pago-en-linea/pago-en-linea-gnp/pago-en-linea-gnp.component';
import { PagoExitosoComponent } from './pago-exitoso/pago-exitoso.component';

const routes: Routes = [
  { path: 'inicio', component: InicioComponent },
  { path: 'mi-cuenta', loadChildren: () => import("./mi-cuenta/mi-cuenta.module").then(m => m.MiCuentaModule) },
  { path: 'archivos', loadChildren: () => import("./mis-archivos/mis-archivos.module").then(m => m.MisArchivosModule) },
  { path: 'cotizacion', loadChildren: () => import("./cotizacion/cotizacion.module").then(m => m.CotizacionModule) },
  { path: 'datos-emision', component: DatosEmisionComponent },
  { path: 'datos-emision-renovacion', component: DatosEmisionRenovacionComponent },
  { path: 'datos-emision-vehiculo', component: DatosEmisionVehiculoComponent },
  { path: 'datos-emision-vehiculo-renovacion', component: DatosEmisionVehiculoRenovacionComponent },
  { path: 'datos-vehiculo', component: DatosVehiculoComponent },
  { path: 'datos-tarjeta', component: DatosTarjetaComponent },
  { path: 'datos-tarjeta-renovacion', component: DatosTarjetaRenovacionComponent },
  { path: 'opciones-pago', loadChildren: () => import('./opciones-pago/opciones-pago.module').then(m => m.OpcionesPagoModule)},
  { path: 'opciones-pago-renovacion', loadChildren: () => import('./opciones-pago-renovacion/opciones-pago.module').then(m => m.OpcionesPagoModule)},
  { path: 'por-fin-asegurado', component: FinalComponent },
  { path: 'login', component: LoginComponent },
  { path: 'auto-login-ayuda', component: LoginAyudaComponent },
  { path: 'login-pel', component: PagoEnLineaComponent },
  { path: 'login-cl', component: PagoEnLineaGnpComponent },
  { path: 'login-pel-renovacion', component: PagoEnLineaRenovacionComponent },
  { path: 'login-cl-renovacion', component: PagoEnLineaGnpRenovacionComponent },
  { path: 'no-esta-auto', component: NoEstaAutoComponent },
  { path: 'login-auth', component: LoginAuthComponent },
  { path: 'notificacion', component: NotificacionComponent },
  { path: 'compra-exitosa', component: PagoExitosoComponent },
  { path: '', redirectTo: '/inicio', pathMatch: 'full' },
  { path: '**', redirectTo: '/inicio', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "enabled", relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
